/* LaceUp custom hooks. Intentionally clean: no third-party trackers or obfuscated code. */

function laceupFormatMoney(cents) {
  const format = window.themeMoneyFormat || '€{{amount}}';
  const amount = (cents / 100).toFixed(2);
  const withComma = amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, '.');
  const noDecimals = Math.round(cents / 100).toString();
  return format
    .replace('{{amount_with_comma_separator}}', withComma)
    .replace('{{amount_no_decimals}}', noDecimals)
    .replace('{{amount}}', amount.replace('.', ','));
}

function laceupRenderDrawer(cart) {
  const linesWrap = document.querySelector('[data-drawer-lines]');
  const totalEl = document.querySelector('[data-drawer-total]');
  if (!linesWrap) return;

  if (cart.items.length === 0) {
    linesWrap.innerHTML = '<p class="drawer-empty">O teu carrinho está vazio.</p>';
  } else {
    linesWrap.innerHTML = cart.items.map(item => `
      <div class="drawer-line" data-line-key="${item.key}">
        <a href="${item.url}"><img class="product-png" src="${item.image}" alt="${item.product_title}"></a>
        <div class="drawer-line__info">
          <strong>${item.product_title}</strong>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="drawer-line__variant">${item.variant_title}</span>` : ''}
          <div class="drawer-line__qty">
            <button type="button" class="qty-btn" data-line-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuir quantidade">−</button>
            <span class="qty-value">${item.quantity}</span>
            <button type="button" class="qty-btn" data-line-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Aumentar quantidade">+</button>
          </div>
          <span class="drawer-line__price">${laceupFormatMoney(item.final_line_price)}</span>
        </div>
        <button type="button" class="drawer-line__remove" data-line-key="${item.key}" aria-label="Remover produto">×</button>
      </div>
    `).join('');
  }

  if (totalEl) totalEl.textContent = laceupFormatMoney(cart.total_price);
  document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
  laceupBindDrawerEvents();
}

function laceupRenderCartPage(cart) {
  const wrapper = document.querySelector('[data-cart-wrapper]');
  if (!wrapper) return;

  if (cart.item_count === 0) {
    window.location.reload();
    return;
  }

  const linesWrap = document.querySelector('[data-cart-lines]');
  const subtotalEl = document.querySelector('[data-cart-subtotal]');

  linesWrap.innerHTML = cart.items.map(item => `
    <div class="cart-row" data-line-key="${item.key}">
      <div class="cart-row__product">
        <a href="${item.url}"><img class="product-png" src="${item.image}" alt="${item.product_title}"></a>
        <div>
          <h3>${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + item.variant_title : ''}</h3>
          <div class="cart-row__price">
            <strong>${laceupFormatMoney(item.price)}</strong>
            ${item.original_price > item.price ? `<s>${laceupFormatMoney(item.original_price)}</s>` : ''}
          </div>
        </div>
      </div>
      <div class="cart-row__qty">
        <div class="qty-pill">
          <button type="button" class="qty-btn" data-line-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuir quantidade">−</button>
          <span class="qty-value">${item.quantity}</span>
          <button type="button" class="qty-btn" data-line-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Aumentar quantidade">+</button>
        </div>
        <button type="button" class="cart-row__remove" data-line-key="${item.key}">Remover</button>
      </div>
      <div class="cart-row__total">${laceupFormatMoney(item.final_line_price)}</div>
    </div>
  `).join('');

  if (subtotalEl) subtotalEl.textContent = laceupFormatMoney(cart.total_price);
  document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
  laceupBindDrawerEvents();
}

function laceupChangeLine(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(res => res.json())
    .then(cart => {
      laceupRenderDrawer(cart);
      laceupRenderCartPage(cart);
    })
    .catch(() => window.location.reload());
}

function laceupBindDrawerEvents() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.onclick = () => {
      const qty = parseInt(btn.dataset.qty, 10);
      laceupChangeLine(btn.dataset.lineKey, Math.max(qty, 0));
    };
  });
  document.querySelectorAll('.drawer-line__remove, .cart-row__remove').forEach(btn => {
    btn.onclick = () => laceupChangeLine(btn.dataset.lineKey, 0);
  });
}

document.addEventListener('DOMContentLoaded', laceupBindDrawerEvents);

/* SOCIAL PROOF NOTIFICATION */
(function () {
  const toast = document.getElementById('SocialProofToast');
  const dataScript = document.getElementById('SocialProofData');
  if (!toast || !dataScript) return;

  let products = [];
  try {
    products = JSON.parse(dataScript.textContent).filter(p => p.image);
  } catch (e) {
    console.warn('Social proof: falha ao ler dados de produtos.', e);
    products = [];
  }
  if (products.length === 0) return;

    const closeBtn = document.getElementById('SocialProofClose');
  const linkEl = document.getElementById('SocialProofLink');
  const imgEl = document.getElementById('SocialProofImg');
  const nameEl = document.getElementById('SocialProofName');
  const detailEl = document.getElementById('SocialProofDetail');

  let dismissed = false;
  let lastProductIndex = -1;
  let hideTimer = null;

  closeBtn.addEventListener('click', () => {
    dismissed = true;
    hideToast();
  });

  function pickProduct() {
    if (products.length === 1) return products[0];
    let index;
    do {
      index = Math.floor(Math.random() * products.length);
    } while (index === lastProductIndex);
    lastProductIndex = index;
    return products[index];
  }

  function showToast() {
    if (dismissed) return;
    const product = pickProduct();
    imgEl.src = product.image;
    imgEl.alt = product.title;
    nameEl.textContent = 'Alguém está a ver';
    detailEl.textContent = product.title;
    linkEl.href = product.url;

    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 6000);
  }

  function hideToast() {
    toast.classList.remove('is-visible');
    clearTimeout(hideTimer);
    setTimeout(() => { toast.hidden = true; }, 350);
  }

  function scheduleNext() {
    if (dismissed) return;
    const delay = (Math.floor(Math.random() * 18) + 18) * 1000; /* 18–35s */
    setTimeout(() => {
      showToast();
      scheduleNext();
    }, delay);
  }

  setTimeout(() => {
    showToast();
    scheduleNext();
  }, 8000); /* primeira notificação 8s depois de abrir o site */
})();

/* MOBILE FILTER DRAWER */
(function () {
  const drawer = document.getElementById('MobileFiltersDrawer');
  const openBtn = document.getElementById('MobileFiltersOpen');
  const closeBtn = document.getElementById('MobileFiltersClose');
  const backdrop = document.getElementById('MobileFiltersBackdrop');
  if (!drawer || !openBtn) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('filters-drawer-open');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('filters-drawer-open');
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  /* COLLECTION FILTERS: desktop auto-submits on change, mobile sort select also submits */
  const desktopForm = document.getElementById('FacetFormDesktop');
  desktopForm?.addEventListener('change', () => desktopForm.submit());

  const desktopSort = document.getElementById('SortBy');
  desktopSort?.addEventListener('change', () => desktopForm?.submit());

  const mobileSort = document.querySelector('.sort-select--mobile');
  mobileSort?.addEventListener('change', () => document.getElementById('FacetFormMobile')?.submit());
})();

document.addEventListener('variant:changed', function(event) {
  // Mantém o sticky ATC e preço sincronizados quando o tema dispara este evento.
  const variant = event.detail?.variant;
  if (!variant) return;
  document.querySelectorAll('[data-sticky-price]').forEach(el => {
    if (variant.price != null) el.textContent = (variant.price / 100).toLocaleString('pt-PT',{style:'currency',currency:'EUR'});
  });
});
